import script from "./TestPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TestPreview.vue?vue&type=script&setup=true&lang=js"

import "./TestPreview.vue?vue&type=style&index=0&id=6f48e94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f48e94c"]])

export default __exports__